import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=e5191d3e"
import script from "./TextareaComponent.vue?vue&type=script&lang=js"
export * from "./TextareaComponent.vue?vue&type=script&lang=js"
import style0 from "./TextareaComponent.vue?vue&type=style&index=0&id=e5191d3e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports